import {Action, getModule, Module, Mutation, VuexModule} from "vuex-module-decorators";
import store from "@/store";
import {IdMapper} from "@/interfaces/state/base";
import {PaginationMeta} from "@/interfaces/common";
import {DivisionPickup, Lading} from "@/interfaces/entity";
import {DivisionPickupParams, PickupLadingParams} from "@/modules/divisionpickup/params";
import {DivisionPickupState} from "@/interfaces/state/divisionpickup";
import {union} from "lodash";
import {
    createDivisionPickup,
    listBillLadingByDivisionPickupId,
    listDivisionPickup
} from "@/modules/divisionpickup/services";


@Module({dynamic: true, name: "divisionPickup", store})
class DivisionPickupModule extends VuexModule implements DivisionPickupState {
    data: IdMapper<DivisionPickup> = {};
    ids: number[] = [];
    meta: PaginationMeta = new PaginationMeta();
    params: DivisionPickupParams = new DivisionPickupParams();

    pickupLadings: IdMapper<Lading> = {};
    pickupLadingIds: string[] = [];
    pickupLadingMeta: PaginationMeta = new PaginationMeta();
    pickupLadingParams: PickupLadingParams = new PickupLadingParams();

    @Mutation
    private MAP_PICKUP(payload: any) {
        const idMapper: IdMapper<DivisionPickup> = {};
        this.meta = payload.meta;
        this.ids = payload.datas?.map((pickup: DivisionPickup) => {
            idMapper[pickup.id!] = {...pickup};
            return pickup.id;
        });
        this.data = idMapper;
    }

    @Mutation MAP_PICKUP_LADING(payload: any) {
        const idMapper: IdMapper<Lading> = {};
        this.pickupLadingMeta = payload.meta
        this.pickupLadingIds = payload.datas?.map((lading: Lading) => {
            idMapper[lading.rowGuid] = lading
            return lading.rowGuid
        })
        this.pickupLadings = idMapper
    }

    @Mutation
    private ADD_DIVISION_PICKUP(payload: DivisionPickup) {
        this.ids = union(this.ids, [payload.id]);
        this.data[payload.id] = payload;
    }

    @Mutation
    private UPDATE_DIVISION_PICKUP_PARAMS(payload: any) {
        this.params = payload;
    }

    @Mutation UPDATE_PICKUP_LADING_PARAMS(payload: any) {
        this.params = payload
    }

    @Action({rawError: true})
    public async listDivisionPickup(params: DivisionPickupParams = new DivisionPickupParams()) {
        const {data} = await listDivisionPickup(params);
        this.MAP_PICKUP(data);
    }

    @Action({rawError: true})
    public updateDivisionPickupParams(payload: any) {
        this.UPDATE_DIVISION_PICKUP_PARAMS(payload);
    }

    @Action( {rawError: true})
    public updatePickupLadingParams(payload: any) {
        this.UPDATE_PICKUP_LADING_PARAMS(payload)
    }

    @Action({rawError: true})
    public async createDivisionPickup(payload: any) {
        const {data} = await createDivisionPickup(payload);
        this.ADD_DIVISION_PICKUP(data.data);
    }

    @Action({rawError: true})
    public async listBillLadingByDivisionPickupId({ id, params = new PickupLadingParams()}) {
        const {data} = await listBillLadingByDivisionPickupId(id, params)
        this.MAP_PICKUP_LADING(data)
    }

}

export const DivisionPickupStore = getModule(DivisionPickupModule)
